module.exports = __webpack_public_path__ + "img/GH-kyujin-top-031.5bc854bd.webp";